'use client'

import { motion } from 'framer-motion'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'
export interface HeroHeadlineProps {
	className?: string
}
export default function HeroHeadline({ className }: HeroHeadlineProps) {
	return (
		<motion.section
			aria-label="Funding Profiles Hero"
			className={cn(
				'flex flex-col items-center px-4 py-8 text-center sm:px-6 md:items-start md:py-16 md:text-left lg:px-8',
				className,
			)}
			initial={{
				opacity: 0,
				y: 20,
			}}
			animate={{
				opacity: 1,
				y: 0,
			}}
			transition={{
				duration: 0.5,
			}}
		>
			<figure className="mb-8 md:mb-10">
				<svg
					width="120"
					height="120"
					viewBox="0 0 120 120"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
					className="text-primary mx-auto md:mx-0"
				>
					<motion.circle
						cx="60"
						cy="60"
						r="50"
						stroke="currentColor"
						strokeWidth="4"
						initial={{
							pathLength: 0,
							opacity: 0,
						}}
						animate={{
							pathLength: 1,
							opacity: 1,
						}}
						transition={{
							duration: 1,
							delay: 0.2,
							ease: 'easeInOut',
						}}
					/>
					<motion.path
						d="M40 60L55 75L80 45"
						stroke="currentColor"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
						initial={{
							pathLength: 0,
							opacity: 0,
						}}
						animate={{
							pathLength: 1,
							opacity: 1,
						}}
						transition={{
							duration: 0.7,
							delay: 0.8,
							ease: 'easeInOut',
						}}
					/>
				</svg>
				<figcaption className="sr-only">
					Abstract illustration representing personalized funding profiles.
				</figcaption>
			</figure>

			<motion.h1
				className="text-foreground mb-6 text-4xl font-bold leading-tight md:text-5xl"
				initial={{
					opacity: 0,
					y: 20,
				}}
				animate={{
					opacity: 1,
					y: 0,
				}}
				transition={{
					duration: 0.5,
					delay: 0.2,
				}}
			>
				Funding Profiles
			</motion.h1>
			<motion.p
				className="text-muted-foreground max-w-[60ch] text-lg md:text-xl"
				initial={{
					opacity: 0,
					y: 20,
				}}
				animate={{
					opacity: 1,
					y: 0,
				}}
				transition={{
					duration: 0.5,
					delay: 0.4,
				}}
			>
				Personalize your grant discovery. Create a funding profile that matches
				your mission.
			</motion.p>
		</motion.section>
	)
}
